// Values are used as translation keys, so be careful if updating
export enum SaveDialogContext {
  CLOSED,
  CREATE = 'create',
  DUPLICATE = 'duplicate',
  SAVE = 'save',
  SAVE_AND_CLOSE = 'saveAndClose',
  SAVE_AS_COPY = 'saveCopy',
}

export type SavePageDialogContext = Extract<
  SaveDialogContext,
  SaveDialogContext.DUPLICATE | SaveDialogContext.SAVE_AS_COPY
>;

export type SaveConflictContext = Extract<
  SaveDialogContext,
  SaveDialogContext.SAVE | SaveDialogContext.SAVE_AND_CLOSE
>;
